import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import Header from '../../components/header';
import { useBreadcrumb } from '../../contexts/breadcrumb';
import { GameDocumentContext } from '../../contexts/game-document';
import { ErrorBoundaryFallback } from '../../components/error-boundary-fallback';

interface PageProps {
  className?: string;
}

const Page = (props: PageProps) => {
  const [state] = useContext(GameDocumentContext);
  const { breadcrumb } = useBreadcrumb();

  return (
    <div className={`page-base ${props.className ?? 'page-base--full'}`}>
      <Header title={state.gameDocument?.name ?? ''} breadCrumbs={breadcrumb} />
      <main>
        <ErrorBoundary
          fallbackRender={(props) => <ErrorBoundaryFallback {...props} />}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
};

export default Page;
